'use client'

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { clearGatewayUserSettings } from '@/core/utils/clearGatewayUserSettings'
import { DEFAULT_GATEWAY_USER_SETTINGS } from '@/core/utils/const/defaultGatewayUserSettings.const'
import type { GatewayUserSettings } from '@/core/utils/interfaces/gatewayUserSettings.interface'
import { loadGatewayUserSettings } from '@/core/utils/loadGatewayUserSettings'
import { saveGatewayUserSettings } from '@/core/utils/saveGatewayUserSettings'

interface GatewaySettingsStore {
  settings: GatewayUserSettings
  hydrated: boolean
  hydrate: () => void
  applyGatewaySettings: (settings: GatewayUserSettings) => void
  resetGatewaySettings: () => void
}

export const useGatewaySettingsStore = create<GatewaySettingsStore>()(
  devtools(
    (set, get) => ({
      settings: DEFAULT_GATEWAY_USER_SETTINGS,
      hydrated: false,
      hydrate: () => {
        if (get().hydrated || typeof window === 'undefined') {
          return
        }

        set({
          settings: loadGatewayUserSettings(),
          hydrated: true,
        })
      },
      applyGatewaySettings: (settings) => {
        saveGatewayUserSettings(settings)
        set({ settings, hydrated: true })
      },
      resetGatewaySettings: () => {
        clearGatewayUserSettings()
        set({ settings: DEFAULT_GATEWAY_USER_SETTINGS, hydrated: true })
      },
    }),
    { name: 'gatewaySettingsStore' }
  )
)
